export class DatoPaginadoModel {
	items: Array<any>;
	links: Array<any>;
	paging: Paging;
}

export class Paging {
	pageNumber: number;
	pageSize: number;
	totalItems: number;
	totalPages: number;
}



